import React from 'react';
import { doc, collection, query, where, onSnapshot } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import SharePanel from '../components/SharePanel';
import LocationList from '../components/LocationList';
import TopHeaderMenu from '../components/TopHeaderMenu';
import MsgNetLoading from '../components/MsgNetLoading';
import { FirebaseContext } from '../index';

class LocationListScreenClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: [],
      isLoading: true,
      evento: null,
      showSharePanel: false,
    };
    this.unlisten = {};
  }

  toggleSharePanel() {
    this.setState((state) => ({
      showSharePanel: !state.showSharePanel,
    }));
  }

  componentDidMount() {
    const { db, params } = this.props;
    const eventoId = params.eventoId;

    // Evento
    const eventoRef = doc(db, 'evento', String(eventoId));
    this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
      let evento = snapshot.exists() ? snapshot.data() : null;
      if (evento) evento.id = snapshot.id;
      this.setState({ evento });
    });

    // Locations
    const eventoIdNum = parseInt(eventoId, 10);
    const locationsQuery = query(
      collection(db, 'location'),
      where('evento_id', '==', eventoIdNum),
      where('visible', '==', true)
    );

    this.unlisten.locations = onSnapshot(locationsQuery, (snapshot) => {
      const locations = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((a, b) => a.orden - b.orden);

      this.setState({ locations, isLoading: false });
    });
  }

  componentWillUnmount() {
    Object.values(this.unlisten).forEach((unsub) => unsub && unsub());
  }

  render() {
    const { evento, locations, isLoading, showSharePanel } = this.state;

    return (
      <div className="min-h-screen bg-gray-900">
        <TopHeaderMenu
          competicion={evento}
          evento={{ nombre: 'Atletas por localización' }}
          onClickBack={() => this.props.navigate(-1)}
          onClickShare={this.toggleSharePanel.bind(this)}
        />

        {isLoading ? (
          <div className="flex justify-center">
            <MsgNetLoading />
          </div>
        ) : (
          <div className="pt-4">
            {showSharePanel && (
              <SharePanel
                close={this.toggleSharePanel.bind(this)}
                url={`/${evento?.id}/locations/`}
                title={`Atletas por localización en ${evento?.nombre}`}
              />
            )}

            {evento && evento.visible ? (
              locations.length > 0 ? (
                <LocationList locations={locations} evento={evento} />
              ) : (
                <div className="text-center py-16">
                  <h2 className="text-lg font-montserrat text-slate-400">
                    No hay localizaciones disponibles
                  </h2>
                </div>
              )
            ) : (
              <div className="text-center py-16">
                <h2 className="text-lg font-montserrat text-slate-400">
                  No se ha podido encontrar el evento
                </h2>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

// Wrapper funcional
function LocationListScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const { db } = React.useContext(FirebaseContext);

  return <LocationListScreenClass navigate={navigate} params={params} db={db} />;
}

export default LocationListScreen;